import React from 'react';
import { ModalContainer } from '../Modal';
import AlertContent from './AlertContent';
import { IAlertContentProps } from './AlertProps';

interface IAlertProps extends IAlertContentProps {
  isActive?: boolean;
}

const Alert: React.FC<IAlertProps> = ({
  title,
  message,
  hideLeftAction,
  onLeftAction,
  onRightAction,
  leftActionLabel,
  rightActionLabel,
  icon,
  iconFill,
  maxWidth,
  isLoading,
  isActive,
  rightActionAppearance,
  leftActionAppearance,
  dataCy = 'modal',
}) => (
  <ModalContainer isActive={isActive} closeOnOutSideClick={false} dataCy={dataCy}>
    <AlertContent
      title={title}
      message={message}
      hideLeftAction={hideLeftAction}
      onLeftAction={onLeftAction}
      onRightAction={onRightAction}
      leftActionLabel={leftActionLabel}
      rightActionLabel={rightActionLabel}
      icon={icon}
      iconFill={iconFill}
      maxWidth={maxWidth}
      isLoading={isLoading}
      rightActionAppearance={rightActionAppearance}
      leftActionAppearance={leftActionAppearance}
    />
  </ModalContainer>
);

export default Alert;
